module.exports = __webpack_public_path__ + "img/A13a_20030051-007008.b52786c1.jpg";